import React, { useEffect, useRef, useState } from "react";
import { AppFooter } from "../LandingPage/Components/Footer/Footer";
import LogoGallery from "../LandingPage/Components/Logo/Logos";
import {
  Typography,
  Table,
  Row,
  Tag,
  Col,
  Space,
  Card,
  Button,
  Image,
  Breadcrumb,
} from "antd";
import InvestBgi from "@assets/KPMG/Invest.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs } from "swiper";
import {
  PercentageOutlined,
  StarOutlined,
  EnvironmentOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import AccordionTable from "./Components/Accordian";

import EV1 from "@assets/KPMG/Solutions/EV/1.jpg";
import EV2 from "@assets/KPMG/Solutions/EV/2.jpg";
import EV3 from "@assets/KPMG/Solutions/EV/3.png";
import EV4 from "@assets/KPMG/Solutions/EV/4.jpg";
import SmartBuilding1 from "@assets/KPMG/Solutions/SmartBuilding/1.jpg";
import SmartBuilding2 from "@assets/KPMG/Solutions/SmartBuilding/2.jpg";
import SmartBuilding3 from "@assets/KPMG/Solutions/SmartBuilding/3.png";
import SmartBuilding4 from "@assets/KPMG/Solutions/SmartBuilding/4.jpeg";
import Solar1 from "@assets/KPMG/Solutions/Solar/1.jpg";
import Solar2 from "@assets/KPMG/Solutions/Solar/2.jpg";
import Solar3 from "@assets/KPMG/Solutions/Solar/3.png";
import Solar4 from "@assets/KPMG/Solutions/Solar/4.jpg";
import { Icon } from "@iconify/react";
import RelatedProjects from "./Components/RelatedPosts";
import { useNavigate, useParams } from "react-router-dom";
import MainHeader from "~/Components/MainHeader/MainHeader";
import Infra from "@assets/KPMG/infra.png";
import { Cell, Label, Pie, PieChart } from "recharts";
import { WrapperLayout } from "~/Components/WrapperLayout/WrapperLayout";
import type { ColumnsType } from "antd/es/table";
import { getRandomBoolean } from "~/Utils/CommonUtils";
import Breadcrumbs from "~/Components/Breadcrumbs/Breadcrumbs";
import { mockDataMultiple } from "../LandingPage/Components/MarketPlace/mock";
import { strings } from "~/Utils/Strings";

const solarIcons = [Solar1, Solar2, Solar3, Solar4];
const EVIcons = [EV1, EV2, EV3, EV4];
const SmartBuildingIcons = [
  SmartBuilding1,
  SmartBuilding2,
  SmartBuilding3,
  SmartBuilding4,
];

const data = [
  {
    title: "Overview",
    data: [
      {
        title: "Estimated Project Cost",
        value: "USD 1,180 Million",
      },
      {
        title: "Financial Feasibility",
        value: "Upstream Phase\nIRR: 10,7%\nNPV: USD 33.87 Million",
      },
      {
        title: "Upstream Phase",
        value: "IRR: 10,7%\nNPV: USD 33.87 Million",
      },
      {
        title: "Downstream Phase – DKI Jakarta",
        value: "IRR: 11,9%\nNPV: USD 23.14 Million",
      },
      {
        title: "Downstream Phase – Bekasi City",
        value: "IRR: 11,8%\nNPV: USD 12.89 Million",
      },
      {
        title: "Downstream Phase – Bekasi Regency",
        value: "IRR: 12,1%\nNPV: USD 28.71 Million",
      },
      {
        title: "Downstream Phase – Bogor Regency",
        value: "IRR: 11,7%\nNPV: USD 27.66 Million",
      },
      {
        title: "Estimated Concession Period",
        value: "30 years including 2 years of construction (2 phases)",
      },
    ],
  },
  {
    title: "Contact Information",
    data: [
      { title: "Estimated Project Cost", value: "USD 1,180 Million" },
      {
        title: "Financial Feasibility",
        value: "Upstream Phase\nIRR: 10,7%\nNPV: USD 33.87 Million",
      },
    ],
  },
];
const data01 = [
  {
    name: "Group A",
    value: 400,
    category: true,
  },
  {
    name: "Group B",
    value: 300,
  },
];

export const InfratechMarketPlaceDetailView = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const navigate = useNavigate();
  const ref = useRef<HTMLDivElement>(null);
  const { id } = useParams();
  const [filteredItem, setFilteredItem] = useState<any>({});
  const [carouselImages, setCarouselImages] = useState<any>([]);
  useEffect(() => {
    let item = mockDataMultiple.projectList.find((item: any) => item.id == id);
    setFilteredItem(item);
    console.log(JSON.stringify(item) + id);
    if (item.solution === "Smart Building Solutions") {
      setCarouselImages(SmartBuildingIcons);
    } else if (item.solution === "Solar Panel Solutions") {
      setCarouselImages(solarIcons);
    } else {
      setCarouselImages(EVIcons);
    }

    // if (item) {
    //     let records = mockDataMultiple.filter(
    //         (item: any) =>
    //             item.categories[0].name === item.categories[0].name &&
    //             item.key !== item.key
    //     );
    // }
  }, [id]);

  const leadingBanks = (
    <Typography.Title level={5}>Leading Banks</Typography.Title>
  );

  const calculateDimension = () => {
    if (ref.current) {
      const { width } = ref.current.getBoundingClientRect();
      return width < 300 ? 275 : width ? 275 : 300;
    } else {
      return 300;
    }
  };
  const breadcrumbItems = [
    { path: "/infratech-marketplace", title: "Infratech Marketplace" },
    { path: "", title: filteredItem.title },
  ];
  return (
    <>
      <WrapperLayout
        title={"Infratech Marketplace"}
        text={
          "Transform your buildings into smarter and greener by bringing seamless connectivity from floor to floor. Harness the power of data collection to unlock valuable insights that will propel the business forward."
        }
        image={Infra}
      >
        <Row
          justify="center"
          style={{ marginBottom: 25 }}
          className={"investment-hub-detail"}
        >
          <Col lg={24} style={{ margin: "1.5rem 0 0 0" }}>
            <Breadcrumbs items={breadcrumbItems} />
          </Col>
          <Col lg={24} style={{ margin: "3.5rem 0 0 0" }}>
            <Row>
              <Col lg={10} style={{ maxHeight: 400,}}>
                <Swiper
                  spaceBetween={10}
                  navigation={true}
                  thumbs={{ swiper: thumbsSwiper }}
                  modules={[FreeMode, Navigation, Thumbs]}
                  className="mySwiper2"
                >
                  {carouselImages &&
                    carouselImages.map((item: any, index: number) => (
                      <SwiperSlide key={`top${index}`}>
                        <img src={item} />
                      </SwiperSlide>
                    ))}
                </Swiper>
                <Swiper
                  onSwiper={(swiper: any) => setThumbsSwiper(swiper)}
                  spaceBetween={10}
                  slidesPerView={4}
                  freeMode={true}
                  watchSlidesProgress={true}
                  modules={[FreeMode, Navigation, Thumbs]}
                  className="mySwiper"
                >
                  {carouselImages &&
                    carouselImages.map((item: any, index: number) => (
                      <SwiperSlide key={`bottom${index}`}>
                        <img src={item} />
                      </SwiperSlide>
                    ))}
                </Swiper>
              </Col>
              <Col lg={14} style={{ paddingLeft: 40 }}>
                <Typography.Title level={3}>
                  {filteredItem
                    ? filteredItem.title
                    : strings.lorem.slice(0, 5)}
                </Typography.Title>
                <Typography.Title level={5}>Description</Typography.Title>{" "}
                <br />
                <Typography.Text>
                  {filteredItem ? filteredItem.description : strings.lorem}
                </Typography.Text>
                <div>
                  <Row style={{ marginTop: "1rem" }}>
                    <Col span={12}>
                      <Icon
                        icon={"game-icons:techno-heart"}
                        style={{
                          marginRight: "1rem",
                          color: "#525252",
                          textAlign: "center",
                          fontSize: 25,
                        }}
                      />
                      <Typography.Text
                        // className="textItemCenter"
                        style={{
                          color: "#003087",
                          textAlign: "center",
                        }}
                      >
                        {filteredItem
                          ? filteredItem.techAdoption
                          : strings.lorem.slice(0, 5)}
                      </Typography.Text>
                    </Col>
                    <Col span={12}>
                      <Icon
                        icon={"simple-line-icons:location-pin"}
                        style={{
                          marginRight: "1rem",
                          color: "#525252",
                          textAlign: "center",
                          fontSize: 25,
                        }}
                      />
                      <Typography.Text
                        style={{
                          color: "#003087",
                          textAlign: "center",
                        }}
                      >
                        {filteredItem
                          ? filteredItem.location
                          : strings.lorem.slice(0, 5)}{" "}
                      </Typography.Text>
                    </Col>
                  </Row>

                  <Row style={{ marginTop: "1rem" }}>
                    <Col span={12}>
                      <Icon
                        icon={"ic:round-star-border"}
                        style={{
                          marginRight: "1rem",
                          color: "#525252",
                          textAlign: "center",
                          fontSize: 25,
                        }}
                      />
                      <Typography.Text
                        style={{
                          color: "#003087",
                          textAlign: "center",
                        }}
                      >
                        {filteredItem
                          ? `${filteredItem.rating} / 5`
                          : strings.lorem.slice(0, 5)}
                      </Typography.Text>
                    </Col>
                    <Col span={12}>
                      <Icon
                        icon={"ic:outline-email"}
                        style={{
                          marginRight: "1rem",
                          color: "#525252",
                          textAlign: "center",
                          fontSize: 25,
                        }}
                      />
                      <Typography.Text
                        style={{
                          color: "#003087",
                          textAlign: "center",
                        }}
                      >
                        annisa.pratiwi@pu.go.id
                      </Typography.Text>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "1rem" }}>
                    <Col span={12}>
                      <Icon
                        icon={"gis:network"}
                        style={{
                          marginRight: "1rem",
                          color: "#525252",
                          textAlign: "center",
                          fontSize: 25,
                        }}
                      />
                      <Typography.Text
                        // className="textItemCenter"
                        style={{
                          color: "#003087",
                          textAlign: "center",
                        }}
                      >
                        {filteredItem
                          ? filteredItem.solution
                          : strings.lorem.slice(0, 5)}
                      </Typography.Text>
                    </Col>
                    <Col span={12}>
                      <Icon
                        icon={"mdi:company"}
                        style={{
                          marginRight: "1rem",
                          color: "#525252",
                          textAlign: "center",
                          fontSize: 25,
                        }}
                      />
                      <Typography.Text
                        style={{
                          color: "#003087",
                          textAlign: "center",
                        }}
                      >
                        {filteredItem
                          ? filteredItem.provider
                          : strings.lorem.slice(0, 5)}{" "}
                      </Typography.Text>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "1rem" }}>
                    <Col span={12}>
                      <Icon
                        icon={"grommet-icons:services"}
                        style={{
                          marginRight: "1rem",
                          color: "#525252",
                          textAlign: "center",
                          fontSize: 25,
                        }}
                      />
                      <Typography.Text
                        // className="textItemCenter"
                        style={{
                          color: "#003087",
                          textAlign: "center",
                        }}
                      >
                        {filteredItem
                          ? filteredItem.type
                          : strings.lorem.slice(0, 5)}
                      </Typography.Text>
                    </Col>
                    <Col span={12}></Col>
                  </Row>
                </div>
                <Row
                  style={{
                    // display: 'flex',
                    // justifyContent: 'flex-end',
                    marginTop: 30,
                  }}
                  className="textTextItemCenter"
                >
                  <Col span={12}>
                    <Space>
                      Share:
                      <Space>
                        <Col span={8}>
                          <Icon
                            icon={"logos:facebook"}
                            style={{
                              marginRight: "1rem",
                              color: "#525252",
                              fontSize: 25,
                            }}
                          />
                        </Col>
                        <Col span={8}>
                          <Icon
                            icon={"logos:pinterest"}
                            style={{
                              marginRight: "1rem",
                              color: "#525252",
                              fontSize: 25,
                            }}
                          />
                        </Col>
                        <Col span={8}>
                          <Icon
                            icon={"icon-park:twitter"}
                            style={{
                              marginRight: "1rem",
                              color: "#525252",
                              fontSize: 25,
                            }}
                          />
                        </Col>
                      </Space>
                    </Space>
                  </Col>
                  <Col span={12}>
                    <Button style={{ padding: 20 }}>
                      <Space>
                        <Typography.Text
                          style={{
                            color: "#00338D",
                          }}
                        >
                          I am Interested in this Project
                        </Typography.Text>
                        <Icon icon={"bx:like"} color="#AB0D82"></Icon>
                      </Space>
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>

        <AccordionTable panels={data} />

        <LogoGallery element={leadingBanks} fullWidth />
      </WrapperLayout>
    </>
  );
};
